// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".maintop[data-v-81c63e4c]{padding-top:100px!important}@media screen and (max-width:960px){.maintop[data-v-81c63e4c]{padding-top:20px!important}}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
